import { MinusCircleOutlined } from '@ant-design/icons';
import { PrimaryColors, Colors, Flex } from '@revenuemarket/cds';
import { SystemCheck } from '@revenuemarket/ui';
import { Breadcrumb } from 'antd';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';
import { css } from '~libs/emotion';

interface Props<T extends Record<string, unknown>> {
  isSelected?: boolean;
  breadcrumbItems: {
    key: number;
    title: React.ReactNode;
  }[];
  item: FlattenTreeResult<T>;
}

const SearchMenuItem = <T extends Record<string, unknown>>({
  isSelected,
  item,
  breadcrumbItems,
}: Props<T>) => {
  return (
    <Flex align="center">
      {isSelected ? <SystemCheck fill={PrimaryColors.primary500} width={24} /> : null}{' '}
      <div
        className={css`
          &&& .ant-breadcrumb {
            width: 275px;

            overflow: hidden;
          }
          &&& .ant-breadcrumb ol {
            flex-wrap: nowwrap;
          }
        `}
      >
        <Breadcrumb
          items={breadcrumbItems}
          style={{
            padding: '4px',
            fontSize: 14,

            marginLeft: isSelected ? 0 : 24,
          }}
          itemRender={(route) => (
            <Flex align="center" gap={4}>
              {route.title}
            </Flex>
          )}
        />
      </div>
      {item?.value?.isActive === false && (
        <MinusCircleOutlined
          width={18}
          height={18}
          style={{
            color: Colors.gray400,
          }}
        />
      )}
    </Flex>
  );
};

export default SearchMenuItem;
